import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '../actions';
import { MyCoverageService } from 'app/services';
import { mergeMap, map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class MyReportsListEffects {
  constructor(
    private actions$: Actions,
    private myCoverageService: MyCoverageService
  ) {}

  loadMyReportsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadMyReportsList),
      mergeMap((action) =>
        this.myCoverageService.getReportsList(action.projectId).pipe(
          map((reports) => actions.loadMyReportsListSuccess({ projectId: action.projectId, reports })),
          catchError((err) =>
            of(actions.loadMyReportsListError({ projectId: action.projectId, payload: err }))
          )
        )
      )
    )
  );

  addMyReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.addMyReport),
      mergeMap((action) =>
        this.myCoverageService.createReport(action.projectId, action.report).pipe(
          switchMap((report) => [
            actions.addMyReportSuccess({ report }),
            actions.loadMyReportsList({ projectId: action.projectId }),
          ]),
          catchError((err) =>
            of(actions.addMyReportError({ payload: err }))
          )
        )
      )
    )
  );

  deleteMyReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteMyReport),
      mergeMap((action) =>
        this.myCoverageService.deleteReport(action.projectId, action.reportId).pipe(
          switchMap(() => [
            actions.deleteMyReportSuccess({ reportId: action.reportId }),
            actions.loadMyReportsList({ projectId: action.projectId }),
          ]),
          catchError((err) =>
            of(actions.deleteMyReportError({ payload: err }))
          )
        )
      )
    )
  );

  updateMyReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.updateMyReport),
      mergeMap((action) =>
        this.myCoverageService.updateReport(action.projectId, action.reportId, action.report).pipe(
          switchMap((report) => [
            actions.updateMyReportSuccess({ report }),
            actions.loadMyReportsList({ projectId: action.projectId }),
          ]),
          catchError((err) =>
            of(actions.updateMyReportError({ payload: err }))
          )
        )
      )
    )
  );
}
